import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoginComponentConfig, LoginForm} from '../../interfaces/login-form.interface';

@Component({
  selector: 'app-urbisoft-login-form',
  templateUrl: './urbisoft-login-form.component.html',
  styleUrls: ['./urbisoft-login-form.component.scss']
})
export class UrbisoftLoginFormComponent implements OnInit {
  @Output() loginForm: EventEmitter<LoginForm> = new EventEmitter<LoginForm>();
  @Output() loginWithGoogle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() loginConfig: LoginComponentConfig = {
    title: 'Login',
    emailLabel: 'Email',
    emailPlaceHolder: 'user@user.com',
    passwordLabel: 'Password',
    passwordPlaceHolder: 'Password',
    loginButton: 'Login',
    noAccountSpan: 'Do not have account?',
    createAccountLabel: 'Create Account',
    createAccountLink: '/',
    loginWithGoogleButton: 'Login with Google',
    styles: {}
  };

  formGroup: FormGroup;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  public login(): void {
    if (!this.formGroup.invalid) {
      const {email, password} = this.formGroup.value;
      this.loginForm.emit({email, password});
    }
  }

  public loginWithGoogleOnClick(): void {
    this.loginWithGoogle.emit(true);
  }

}
